import { Status } from "../doa-forecast/DoaForecastModels";

export type JobDetail = {
  jobDetail: string;
  jobsRequired: number;
  totalAvailable: number;
  matchedAvailable: number;
  tsc: number;
  short: number;
}

export type JobStats = {
  jobId: number;
  flag545: number;
  jobDescription: string;
  jobsRequired: number;
  totalAvailable: number;
  matchedAvailable: number;
  tsc: number;
  short: number;
  jobDetails: JobDetail[]
}

export enum DetailsItemType {
  regular = 'regular',
  coastwise = 'coastwise',
  jobs = 'squamish'
}

export type DetailsItem = {
  type: DetailsItemType,
  snapshotStartIndex: number,
  snapshotEndIndex: number,
  jobStats: JobStats[]
};

export interface IDoaForecastStatsData {
  dispatchDate: string;
  dispatch: string;
  dispatchDescription: string;
  availabilityStatus: Status;
  physicalDispatchStatus: Status;
  jobRequired: number;
  totalEmployees: number;
  totalEmployeesNotEligible: number;
  totalEmployeesEligible: number;
  lastUpdate: string | null;
  lastRefresh: string | null;
  details: DetailsItem[];
  refreshTime: string;
  refreshTimeContext: string;
}
